var _rect, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFacebooknew = function SvgFacebooknew(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#475993"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.258 16.522h1.754v7.22c0 .142.115.258.258.258h2.974a.258.258 0 0 0 .258-.258v-7.186h2.016a.258.258 0 0 0 .256-.229l.307-2.658a.258.258 0 0 0-.257-.288h-2.322v-1.666c0-.502.27-.757.804-.757h1.518a.258.258 0 0 0 .258-.258V8.26a.258.258 0 0 0-.258-.258h-2.092A2.05 2.05 0 0 0 17.636 8c-.363 0-1.625.071-2.622.988-1.105 1.017-.951 2.234-.915 2.445v1.948h-1.84a.258.258 0 0 0-.259.258v2.625c0 .142.116.258.258.258z",
    fill: "#fff"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebooknew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebooknew.d4212b49.svg";
export { ForwardRef as ReactComponent };